module.exports = __webpack_public_path__ + "media/images/xpass/xpass-token-4b59f5332d91bb7a3ce3933a83208d19.png";